import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import TableArrowDown from 'component/svgComponents/tableArrowDown'
import moment from 'moment'
import checkIcon from 'images/check-icon.svg'
import SupplyRemoveModal from 'component/ircListsSupply/SupplyRemoveModal'
import { isEmpty } from 'utils/validations'

const SupplyTable = ({
  ircList,
  handleOrder,
  handleSyncModal,
  translate,
  showViewModal,
  onExclude
}) => {
  const [orderByAsc,setOrderByAsc] = useState(false)
  const tableRef = useRef(null)
  const [height,setHeight] = useState(0)
  const [selectedSupplyList,setSelectedSupplyList] = useState({})
  // Pagination below table
  const PAGINATION_HEIGHT = 71
  // Search and Filter
  const TOP_ACTIONS = 95
  // TOOLBAR + Title
  const TOP_BAR = 67 + 50

  useEffect(() => {
    setHeight(window.innerHeight)
    const calculateHeight = () => {
      setHeight(window.innerHeight)}
    window.addEventListener("resize", calculateHeight)
    return () => window.removeEventListener("resize", calculateHeight)
  }, [])

  const changeOrder = (newOrder) => {
    setOrderByAsc(newOrder)
    handleOrder(newOrder)
  }

  useEffect(() => {

    if(height < 868 && height !== 0) {
      const responsiveHeight = height - (PAGINATION_HEIGHT + TOP_ACTIONS + TOP_BAR + 100)
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `${responsiveHeight}px`
    }
    else {
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `500px`
    }
  }, [height])
  const renderHeader = () => (
      <tr className='pictograms-tr'>
       <th style={{width: "27%"}} >Nome da lista</th>
       <th style={{width: "14%"}} >{translate('irc.store')}s</th>
       <th style={{width: "14%"}} >{translate('field.period.hint')}</th>
       <th className='irc-list-supply-table-cursor' style={{cursor: "pointer", width:"7%"}}  onClick={() => changeOrder(!orderByAsc)} >
        {translate('irc.status')} {<TableArrowDown active={true} reverse={!orderByAsc} />}
       </th>

       <th style={{width: "17%", textAlign:"left"}}   >
         Sincronização
       </th>
        
       <th  className='text-center' style={{width: "9%"}}>
         Visualizar
       </th>
      
       <th className='text-center'>
         Excluir prog. Futura
       </th>
       
      </tr>
    )

  const handleExclude = (record) => {
    if(record.excluded || record.totalSync || moment().isAfter(record.dtEnd)) return
    setSelectedSupplyList(record)
  }

  const renderBody = () => {

    
    const renderRecord = (record) => {
      const { idIrcSupply,idStore} = record
      return (
        <tr key={`${idIrcSupply}-${idStore}`}>
        
          <td className='CellWithComment' style={{width: "27%"}} > <span className='list-description'>{record.listDescription}</span> <span className='CellComment'>{record.listDescription}</span></td>

          <td style={{width: "14%",textTransform: "capitalize"}} >{record.idStore} - {record.dsStore.replace("LOJA", "").toLowerCase()}</td>

          <td style={{width: "14%"}} >{`${moment(record.dtBegin).format('DD/MM/YYYY')} - ${moment(record.dtEnd).format('DD/MM/YYYY')}`}</td>
          
          <td style={{width: "7%"}}>
            {moment().isBetween(record.dtBegin,record.dtEnd) ? "Ativa" : "Inativa"}
          </td>

          <td onClick={() =>  ( record.inProcess || record.excluded ) && handleSyncModal(true, record)} style={{width: "17%", textAlign:"left"}} >
            {record.excluded 
            ? <div style={{cursor: "pointer"}} className='sync-div'> <img key='checkIcon' src={checkIcon} /> <span style={{color: "#b42a27", borderBottom: "1px solid", borderColor: "#41A017"}}>Programação cancelada</span> </div> 
            : record.inProcess ? <div style={{cursor: "pointer"}} className='sync-div'> <img key='checkIcon' src={checkIcon} /> <span style={{color: "#41A017", borderBottom: "1px solid", borderColor: "#41A017"}}> {record.totalSync ? "Sincronizado" : "Parcial"} </span> </div> 
            : <span style={{color:"#6F676C", fontWeight:600}}>Em processamento</span>}
          </td>

          <td onClick={() => showViewModal(true,record)} className='text-center' style={{width: "9%"}}>
            <a className='padding' role='button'>
              <i className='glyph glyph-eye icon-size' />
            </a>
          </td>

          <td onClick={() => handleExclude(record)}>             
              <a className={`color-danger dwapadding ${record.excluded || record.totalSync || moment().isAfter(record.dtEnd)  ? 'disabled-link' : ''} `} role='button'>
                <i className='glyph glyph-trash-can icon-size' />
              </a>
          </td>
        
        </tr>
      )
    }

    return ircList.map(renderRecord)
  }

  return (
    <>
      <table  cellPadding={0} cellSpacing={0} className={`supply-list-table-new new pictograms-table }`}>
        <thead ref={tableRef}>{renderHeader()}</thead>
        <tbody className='tbody-mission-block'  onScroll={(e) => {
          if(e.currentTarget.scrollTop > 20) {
            tableRef.current.classList.add("shadow-table-header-mission-block")
          }
          else {
            tableRef.current.classList.remove("shadow-table-header-mission-block")
          }
        }} >{renderBody()}</tbody>
        <tfoot style={{height: "1px",background:"#D3D2D6"}}></tfoot>
      </table>
      
      {!isEmpty(selectedSupplyList) && <SupplyRemoveModal action={() => onExclude(selectedSupplyList.codeProcess, () => setSelectedSupplyList({}))} closeModal={() => setSelectedSupplyList({})} record={selectedSupplyList} />}
    </>
  )
}

SupplyTable.propTypes = {
  cdMissionList: PropTypes.array.isRequired,
  editModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  handleResize: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  ircList: PropTypes.array.isRequired,
  setCdMissionList: PropTypes.func.isRequired,
  size: PropTypes.number.isRequired,
  translate: PropTypes.func.isRequired,
  removeSelected: PropTypes.func.isRequired,
  handleOrder: PropTypes.func.isRequired,
  showViewModal:PropTypes.bool,
  handleSyncModal: PropTypes.func.isRequired,
  onExclude: PropTypes.func.isRequired
}

export default SupplyTable
